import * as fromState from '../states/country-state.state';
import {SelectInputOption} from '@ibe.components/common/inputs/select-input-indra/models/select-input-option';
import * as fromActions from '../actions/country-state.actions';
import { COUNTRIES_TRANSLATION_KEY } from '@ibe.config';

export interface State extends fromState.State {

}

const initialState: fromState.State = fromState.initialState;

/** mappers */
const mapUSStatesCodesOptions = (states: any[]) =>
	states.map(state => ({text: state.state, value: state.code} as SelectInputOption));

const mapCountryConversionCodesOptions = (countries: any[]) =>
	countries.map(country => ({ text: country.country, value: country.alpha_2_code } as SelectInputOption));

const mapCountryCodesPrefixOptions = (countries: any[]) =>
	countries.map(country => ({ text: COUNTRIES_TRANSLATION_KEY + country.code.toLowerCase(), value: country.prefix } as SelectInputOption));

const mapCountryCodesOptions = (countries: any[]) =>
	countries.map(country => ({ text: COUNTRIES_TRANSLATION_KEY + country.code.toLowerCase(), value: country.code } as SelectInputOption));

/** getters */
export const getCountryCodes = (state: State) => state.countryCodes;
export const getCountryCodesPrefixOpts = (state: State) => state.countryCodesPrefixOpts;
export const getCountryCodesOpts = (state: State) => state.countryCodesOpts;
export const getCountryConversionCodes = (state: State) => state.countryConversionCodes;
export const getCountryConversionCodesOpts = (state: State) => state.countryConversionCodesOpts;
export const getUSAirports = (state: State) => state.USAirports;
export const getUSStates = (state: State) => state.USStates;
export const getSchengenCountryCodes = (state: State) => state.schengenCountryCodes;
export const getEUCountryCodes = (state: State) => state.euCountryCodes;

export function reducer(state = initialState, action: fromActions.Actions) {
	switch (action.type) {
		case fromActions.ActionTypes.LOAD_COUNTRY_CODES_SUCCESS: {
			const countryCodesPrefix = mapCountryCodesPrefixOptions(action.payload);
			const countryCodesOpts = mapCountryCodesOptions(action.payload);
			return {
				...state,
				countryCodes: action.payload,
				countryCodesPrefixOpts: countryCodesPrefix,
				countryCodesOpts: countryCodesOpts
			};
		}
		case fromActions.ActionTypes.LOAD_COUNTRY_CONVERSION_CODES_SUCCESS: {
			const countries = mapCountryConversionCodesOptions(action.payload);
			return {
				...state,
				countryConversionCodes: action.payload,
				countryConversionCodesOpts: countries
			};
		}
		case fromActions.ActionTypes.LOAD_US_AIRPORTS_SUCCESS: {
			return {
				...state,
				USAirports: action.payload
			};
		}
		case fromActions.ActionTypes.LOAD_US_STATES_SUCCESS: {
			const states = mapUSStatesCodesOptions(action.payload);
			return {
				...state,
				USStates: states
			};
		}
		case fromActions.ActionTypes.LOAD_SCHENGEN_COUNTRY_CODES_SUCCESS: {
			return {
				...state,
				schengenCountryCodes: action.payload
			};
		}
		case fromActions.ActionTypes.LOAD_EU_COUNTRY_CODES_SUCCESS: {
			return {
				...state,
				euCountryCodes: action.payload
			};
		}
		default:
			return state;
	}
}
